import { END_POINTS } from '../helpers';
import { BrandData, CommonBody } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetBrandsTypeResponse = {
  count: number;
  data: BrandData[];
};

export const brandApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.query<
      CommonResponse & { data: GetBrandsTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getBrands}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),

    deleteBrand: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteBrand}/${id}`,
        method: 'DELETE',
      }),
    }),
    getBrandById: builder.query<CommonResponse & { data: BrandData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getBrandById}/${id}`,
        method: 'GET',
      }),
    }),

    addBrand: builder.mutation<CommonResponseType & { data: BrandData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addBrand}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BRAND'],
    }),
    updateBrand: builder.mutation<
      CommonResponseType & { data: BrandData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBrand}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddBrandMutation,
  useUpdateBrandMutation,
  useLazyGetBrandsQuery,
  useLazyDeleteBrandQuery,
  useLazyGetBrandByIdQuery,
} = brandApi;
